import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const shodan = defineConnector({
  identifier: "shodan",
  name: "Shodan",
  tagLine: "Internet device search engine",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api\\.shodan\\.io/.*",
  auth: (app) => queryAuth([{ name: "key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Visit [Shodan](https://www.shodan.io/) and sign in. Navigate to **My Account** to find your API key.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "Shodan API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.shodan.io/api-info",
  },
});
